<template>
    <div >
        
          <el-dialog  title="修改密码" :visible.sync="dialogVisible" width="600px" :modal-append-to-body="false">
           
            <el-form
              :model="ruleForm"
              :rules="rules"
              ref="ruleForm"
              label-width="120px"
              class="demo-ruleForm"
            >
              <el-form-item label="原密码" prop="pass">
                <el-input v-model="ruleForm.pass"  :type="isPassword?'password':'text'" placeholder="请输入原密码" >
                        <i slot="suffix" >
                            <svg-icon v-if="isPassword" @click="isPassword=!isPassword" 
                                :style="{ fontSize: calcFontSize(16, 16 * 0.3) }"
                                icon-class="biyan" class="biyan"></svg-icon>
                            <svg-icon v-else  @click="isPassword=!isPassword"
                                :style="{ fontSize: calcFontSize(16, 16 * 0.3)}"
                                icon-class="zhengyan" class="biyan"></svg-icon>
                        </i>
                </el-input>
              </el-form-item>
              <el-form-item label="新密码" prop="newPass">
                <el-input v-model="ruleForm.newPass" :type="isNewPassword?'password':'text'" placeholder="请输入新密码">
                        <i slot="suffix" >
                            <svg-icon v-if="isNewPassword" @click="isNewPassword=!isNewPassword" 
                                :style="{ fontSize: calcFontSize(16, 16 * 0.3) }"
                                icon-class="biyan" class="biyan"></svg-icon>
                            <svg-icon v-else  @click="isNewPassword=!isNewPassword"
                                :style="{ fontSize: calcFontSize(16, 16 * 0.3) }"
                                icon-class="zhengyan" class="biyan"></svg-icon>
                        </i>
                </el-input>
              </el-form-item>
              <el-form-item label="确认新密码" prop="checkPass">
                <el-input v-model="ruleForm.checkPass" :type="isCheckPassword?'password':'text'" placeholder="请再次输入新密码">
                     <i slot="suffix" >
                            <svg-icon v-if="isCheckPassword" @click="isCheckPassword=!isCheckPassword" 
                                :style="{ fontSize: calcFontSize(16, 16 * 0.3) }"
                                icon-class="biyan" class="biyan"></svg-icon>
                            <svg-icon v-else  @click="isCheckPassword=!isCheckPassword"
                                :style="{ fontSize: calcFontSize(16, 16 * 0.3) }"
                                icon-class="zhengyan" class="biyan"></svg-icon>
                        </i>
                </el-input>
              </el-form-item>
            </el-form>
             <div slot="footer" class="dialog-footer">
               <el-button class="dialogBtn" type="primary" @click="submitForm('ruleForm'),dialogVisible == false">确 定</el-button>
             </div>
          </el-dialog>
        </div>
</template>
<script>
import {isPasswordValid} from '@/utils/validate.js'
import {updatePassword} from '@/services/role'
export default {
 
    data(){
            var validatePass = (rule, value, callback) => {
                if (value === "" || !isPasswordValid(value)) {
                    callback(new Error("请输入包含8位以上的数字、字母、特殊字符中任意两类的组合"));
                } else {
                    callback();
                }
            };
            var validatePass2 = (rule, value, callback) => {
                if (value === "") {
                    callback(new Error("请再次输入密码"));
                } else if (value !== this.ruleForm.newPass) {
                    callback(new Error("两次输入密码不一致!"));
                } else {
                    callback();
                }
            };
        return {
            isPassword:true,
            isNewPassword:true,
            isCheckPassword:true,
            dialogVisible: false,
            ruleForm: {
                    pass: "",
                    newPass: "",
                    checkPass: ""
                },
            rules: {
                    pass: [{required: true, message: "请输入密码", trigger: "blur"}],
                    newPass: [{required: true, validator: validatePass, trigger: "blur"}],
                    checkPass: [{required: true, validator: validatePass2, trigger: "blur"}]
                },
        }
    },
    methods:{

      

        openModel(){
                this.dialogVisible=true
                this.isPassword=true
                this.isNewPassword=true
                this.isCheckPassword=true
                if (this.$refs.ruleForm) {
                    this.$refs.ruleForm.resetFields();
                }
        },
            // 修改密码
            async submitForm(formName) {
              
           
                if (
                    this.ruleForm.newPass != this.ruleForm.checkPass ||
                    // !isPasswordValid(this.ruleForm.newPass) ||
                    this.ruleForm.pass == "" ||
                    this.ruleForm.newPass == " "
                ) {
                    this.$refs[formName].validate(valid => {});
                    this.dialogVisible = true;
                   
                } else {
                    const result =await updatePassword(this.ruleForm.pass,this.ruleForm.newPass)
                    if(result&&result.code==0){
                        this.$message({
                                message: "修改成功!", type: "success",
                                showClose: true,duration: 2000
                         });
                                
                        
                        this.dialogVisible = false;   
                               
                    }
                }
            },
    }
}
</script>
<style scoped lang='scss'>
.title{
  height: 22px;
  font-size: 16px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  color: #575B6C;;
  line-height: 22px;
  margin-bottom: 24px;
}
.biyan{
  cursor: pointer!important;
  color: #9A9DA7;
}
</style>


// WEBPACK FOOTER //
// src/components/changePassword.vue